import { Chart, ChartArea, ChartLegend, ChartSeries, ChartSeriesItem, ChartTooltip, RenderEvent, SeriesVisualArgs } from '@progress/kendo-react-charts';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { ExpansionPanel, ExpansionPanelContent } from '@progress/kendo-react-layout';
import 'hammerjs';
import ReportService from '../Services/ReportService';
import { Circle as CircleGeometry } from '@progress/kendo-drawing/geometry';
import { Layout, Text } from '@progress/kendo-drawing';
import { AppConstants } from '../Shared/Constants/AppConstant';

export const DutyOncall = (props: any) => {
    const [categories, setCategories] = useState<any>([]);
    const [subCategories, setSubCategories] = useState<any>([]);
    const [categoriesCopy, setCategoriesCopy] = useState<any>([]);
    const [subCategoriesCopy, setSubCategoriesCopy] = useState<any>([]);

    const [totalHour, setTotalHours] = useState<any>()
    const [totalMinute, setTotalMinute] = useState<any>()
    const [clickedSegment, setClickedSegment] = useState<any>({ name: "", totalHours: 0, totalMinutes: 0, id: 0 });
    const [expanded, setExpanded] = useState<any>();
    const [totalWeeks, setTotalWeeks] = useState(0);
    const [totalDutyOnCallPeriod, setTotalDutyOnCallPeriod] = useState(0);

    const [categoriesForWithDutyDay, setCategoriesForWithDutyDay] = useState<any>([]);
    const [subCategoriesForWithDutyDay, setSubCategoriesForWithDutyDay] = useState<any>([]);
    const [categoriesForWithDutyDayCopy, setCategoriesForWithDutyDayCopy] = useState<any>([]);
    const [subCategoriesForWithDutyDayCopy, setSubCategoriesForWithDutyDayCopy] = useState<any>([]);

    const [clickedSegmentForWithDutyDay, setClickedSegmentForWithDutyDay] = useState<any>({ name: "", totalHours: 0, totalMinutes: 0, id: 0 });
    const [expandedForWithDutyDay, setExpandedForWithDutyDay] = useState<any>();
    const [averageHoursWithDutyDay, setAverageHoursWithDutyDay] = useState<any>();
    const [averageMinutesWithDutyDay, setAverageMinutesWithDutyDay] = useState<any>();
    const [totalSessionWithDutyDay, setTotalSessionWithDutyDay] = useState<any>();
    const [categoriesWithDutyDayExist, setCategoriesWithDutyDayExist] = useState(false);

    const [categoriesForWithoutDutyDay, setCategoriesForWithoutDutyDay] = useState<any>([]);
    const [subCategoriesForWithoutDutyDay, setSubCategoriesForWithoutDutyDay] = useState<any>([]);
    const [categoriesForWithoutDutyDayCopy, setCategoriesForWithoutDutyDayCopy] = useState<any>([]);
    const [subCategoriesForWithoutDutyDayCopy, setSubCategoriesForWithoutDutyDayCopy] = useState<any>([]);

    const [clickedSegmentForWithOutDutyDay, setClickedSegmentForWithOutDutyDay] = useState<any>({ name: "", totalHours: 0, totalMinutes: 0, id: 0 });
    const [expandedForWithOutDutyDay, setExpandedForWithOutDutyDay] = useState<any>();
    const [averageHoursWithOutDutyDay, setAverageHoursWithOutDutyDay] = useState<any>();
    const [averageMinutesWithOutDutyDay, setAverageMinutesWithOutDutyDay] = useState<any>();
    const [totalSessionWithOutDutyDay, setTotalSessionWithOutDutyDay] = useState<any>();
    const [categoriesWithOutDutyDayExist, setCategoriesWithOutDutyDayExist] = useState(false);

    //To greyout the chart if no data
    const noCategoriesData = [{ id: 1, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", totalSessions: 1 }];
    const noSubCategoriesData = [
        { id: 1, categoryName: "", name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: AppConstants.DCC_Category_Id, totalSessions: 0.4, isUserDefined: false, percentage: 0 },
        { id: 2, categoryName: "", name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: AppConstants.DCC_Category_Id, totalSessions: 0.3, isUserDefined: false, percentage: 0 },
        { id: 3, categoryName: "", name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: AppConstants.DCC_Category_Id, totalSessions: 0.2, isUserDefined: false, percentage: 0 },
        { id: 4, categoryName: "", name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: AppConstants.DCC_Category_Id, totalSessions: 0.1, isUserDefined: false, percentage: 0 }
    ];

    useEffect(() => {
        getDutyDayReportDetails();
    }, []);

    const getDutyDayReportDetails = () => {
        let payload: any = {};
        payload.startDate = new Date(props.startDate.getFullYear(), props.startDate.getMonth(), props.startDate.getDate(), 0, 0, 0);
        payload.endDate = new Date(props.endDate.getFullYear(), props.endDate.getMonth(), props.endDate.getDate(), 23, 59, 59);
        payload.employerID = props.employerID;
        ReportService.getDutyDayDetailsForReport(payload).then((response) => {
            if (response && response.data) {
                //Set values for ICC and DCC categories with duty oncall categories
                if (response.data.dutyOnCallCategories && response.data.dutyOnCallCategories.length > 0) {
                    response.data.dutyOnCallCategories.map((element: any) => {
                        element.color = getColorForCategory(element, response.data.dutyOnCallSubCategories);
                    });
                    setCategories(response.data.dutyOnCallCategories);
                    setSubCategories(subCategoriesToSet);
                    setCategoriesCopy(JSON.parse(JSON.stringify(response.data.dutyOnCallCategories)));
                    setSubCategoriesCopy(JSON.parse(JSON.stringify(subCategoriesToSet)));

                    setTotalHours(response.data.totalHours);
                    setTotalMinute(response.data.totalMinutes);
                    setTotalWeeks(response.data.totalNumberOfWeeks);
                    setTotalDutyOnCallPeriod(response.data.totalNumberOfDutyOnCallPeriod);
                    const initialExpanded: any = response.data.dutyOnCallCategories.reduce(
                        (acc: any, cur: any) => ({ ...acc, [cur.id]: true }),
                        {}
                    );
                    setExpanded({ ...initialExpanded });
                }

                if (response.data.categoriesWithDutyDay.length > 0) {
                    response.data.categoriesWithDutyDay.map((element: any) => {
                        element.color = getColorForCategoryWithDutyDay(element, response.data.subCategoriesWithDutyDay);
                    });
                    setCategoriesForWithDutyDay(response.data.categoriesWithDutyDay);
                    setSubCategoriesForWithDutyDay(subCategoriesToSetForWithDutyDay);
                    setCategoriesForWithDutyDayCopy(JSON.parse(JSON.stringify(response.data.categoriesWithDutyDay)));
                    setSubCategoriesForWithDutyDayCopy(JSON.parse(JSON.stringify(subCategoriesToSetForWithDutyDay)));
                    setAverageHoursWithDutyDay(response.data.averageHoursWithDutyDay)
                    setAverageMinutesWithDutyDay(response.data.averageMinutesWithDutyDay)
                    setTotalSessionWithDutyDay(response.data.totalSessionsWithDutyDay)
                    setCategoriesWithDutyDayExist(true)
                }
                else {
                    setCategoriesForWithDutyDay(noCategoriesData);
                    setSubCategoriesForWithDutyDay(noSubCategoriesData);
                    setAverageHoursWithDutyDay(0);
                    setAverageMinutesWithDutyDay(0);
                    setTotalSessionWithDutyDay(0);
                }
                const initialExpandedWithDutyDay: any = response.data.categoriesWithDutyDay.reduce(
                    (acc: any, cur: any) => ({ ...acc, [cur.id]: true }),
                    {}
                );
                setExpandedForWithDutyDay({ ...initialExpandedWithDutyDay });
            }

            //Set values for activities with outduty day oncall period
            if (response.data.categoriesWithOutDutyDay.length > 0) {
                response.data.categoriesWithOutDutyDay.map((element: any) => {
                    element.color = getColorForCategoryWithOutDutyDay(element, response.data.subCategoriesWithOutDutyDay);
                });
                setCategoriesForWithoutDutyDay(response.data.categoriesWithOutDutyDay);
                setSubCategoriesForWithoutDutyDay(subCategoriesToSetForWithOutDutyDay);
                setCategoriesForWithoutDutyDayCopy(JSON.parse(JSON.stringify(response.data.categoriesWithOutDutyDay)));
                setSubCategoriesForWithoutDutyDayCopy(JSON.parse(JSON.stringify(subCategoriesToSetForWithOutDutyDay)));
                setAverageHoursWithOutDutyDay(response.data.averageHoursWithOutDutyDay)
                setAverageMinutesWithOutDutyDay(response.data.averageMinutesWithOutDutyDay)
                setTotalSessionWithOutDutyDay(response.data.totalSessionsWithOutDutyDay)
                setCategoriesWithOutDutyDayExist(true)
            }
            else {
                setCategoriesForWithoutDutyDay(noCategoriesData);
                setSubCategoriesForWithoutDutyDay(noSubCategoriesData);
                setAverageHoursWithOutDutyDay(0);
                setAverageMinutesWithOutDutyDay(0);
                setTotalSessionWithOutDutyDay(0);
            }
            const initialExpandedWithOutDutyDay: any = response.data.categoriesWithOutDutyDay.reduce(
                (acc: any, cur: any) => ({ ...acc, [cur.id]: true }),
                {}
            );
            setExpandedForWithOutDutyDay({ ...initialExpandedWithOutDutyDay });
        })
    }

    //ICC and DCC categories if the isOnduty checkbox is checked

    //To get color for category
    let subCategoriesToSet: any = [];
    const getColorForCategory = (category: any, subCategoriesList: any) => {
        let subcategories = subCategoriesList.filter((x: { categoryId: any; }) => x.categoryId == category.id);
        let total = 10 / subcategories.length;
        subcategories.forEach((element: any, index: any) => {
            let opacity = (total * (subcategories.length - index)) / 10;
            element.color = getColorForSubCategory(element.categoryId, opacity);
            subCategoriesToSet.push(element);
        });

        let map: any = {
            [AppConstants.DCC_Category_Id]: '#0967B1',
            [AppConstants.ICC_Category_Id]: '#DA1F6C',
            [AppConstants.Non_Clinical_Work_Category_Id]: '#008E82',
            [AppConstants.Training_And_Supervision_Category_Id]: '#6F4F9B',
            [AppConstants.CPD_Category_Id]: '#EA580D',
            [AppConstants.Break_Category_Id]: '#76A227',
            [AppConstants.Leave_Category_Id]: '#DA1F6C',
            [AppConstants.Duty_On_Call_Period_Category_Id]: '#50535a',
            [AppConstants.Academic_Category_Id]: '#000000',
        };
        if (category.id > 0 && category.id <= 8) {
            return map[category.id];
        }
    }

    //To get color for subcategory
    const getColorForSubCategory = (categoryId: any, opacity: any) => {
        let alpha = opacity - 0.1;
        let map: any = {
            [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,' + alpha + ')',
            [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,' + alpha + ')',
            [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,' + alpha + ')',
            [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,' + alpha + ')',
            [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,' + alpha + ')',
            [AppConstants.Break_Category_Id]: 'rgba(118, 162,39,' + alpha + ')',
            [AppConstants.Leave_Category_Id]: 'rgba(218,31,108,' + alpha + ')',
            [AppConstants.Duty_On_Call_Period_Category_Id]: 'rgba(80,83,90,' + alpha + ')',
            [AppConstants.Academic_Category_Id]: 'rgba(0,0,0,' + alpha + ')',
        };

        if (categoryId > 0 && categoryId <= 8) {
            return map[categoryId];
        }
    }

    const onAction = useCallback(
        (id: any) => {
            setExpanded({ ...expanded, [id]: !expanded[id] });
        },
        [expanded]
    );

    //To show the center of donut chart
    let center: any;
    let radius: any;

    //To create visuals for donut chart center
    const visualHandler = (e: SeriesVisualArgs) => {
        // Obtain parameters for the segments
        center = e.center;
        radius = e.innerRadius;

        // Create default visual
        return e.createVisual();
    };

    //To render the donut chart center
    const onRender = (e: RenderEvent) => {
        // The center and radius are populated by now.
        // We can ask a circle geometry to calculate the bounding rectangle for us.
        if (center) {
            const circleGeometry = new CircleGeometry([center.x, center.y], radius);
            const bbox = circleGeometry.bbox();

            // Render the text
            const heading = new Text(clickedSegment.name ? clickedSegment.totalHours + 'h ' + clickedSegment.totalMinutes + 'm' : totalHour + 'h ' + totalMinute + 'm', [0, 0], {
                font: "bold 20px Helvetica Now,Helvetica,Arial,'sans- serif'",
            });

            const line1 = new Text(clickedSegment.name ? clickedSegment.name : '', [0, 0], {
                font: "bold 20px Helvetica Now,Helvetica,Arial,'sans- serif'",
            })

            // Reflow the text in the bounding box
            const layout = new Layout(bbox, {
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                spacing: 5,
                orientation: 'vertical'
            });

            layout.append(heading, line1);
            layout.reflow();

            // Draw it on the Chart drawing surface
            if (e.target.surface) {
                e.target.surface.draw(layout);
            }
        }
    };

    //Donut chart OnClick state
    const onSeriesClick = (event: any) => {
        const { category, series } = event.point;
        let categoryId = event.series.name == "categories" ? event.dataItem.id : event.dataItem.categoryId;
        let map: any = {
            [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,0.2)',
            [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,0.2)',
            [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,0.2)',
            [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,0.2)',
            [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,0.2)',
            [AppConstants.Break_Category_Id]: 'rgba(118, 162,39,0.2)',
            [AppConstants.Leave_Category_Id]: 'rgba(218,31,108,0.2)',
            [AppConstants.Duty_On_Call_Period_Category_Id]: 'rgba(80,83,90,0.2)',
            [AppConstants.Academic_Category_Id]: 'rgba(0,0,0,0.2)',
        };

        let mapO: any = {
            [AppConstants.DCC_Category_Id]: '#0967B1',
            [AppConstants.ICC_Category_Id]: '#DA1F6C',
            [AppConstants.Non_Clinical_Work_Category_Id]: '#008E82',
            [AppConstants.Training_And_Supervision_Category_Id]: '#6F4F9B',
            [AppConstants.CPD_Category_Id]: '#EA580D',
            [AppConstants.Break_Category_Id]: '#76A227',
            [AppConstants.Leave_Category_Id]: '#DA1F6C',
            [AppConstants.Duty_On_Call_Period_Category_Id]: '#50535a',
            [AppConstants.Academic_Category_Id]: '#000000',
        };

        categories.forEach((element: { id: any | number; color: any; }) => {
            if (element.id != categoryId) {
                element.color = map[element.id];
            } else {
                element.color = mapO[element.id];
            }
        });

        let alpha = 0.2;
        let mapSubCategory: any = {
            [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,' + alpha + ')',
            [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,' + alpha + ')',
            [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,' + alpha + ')',
            [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,' + alpha + ')',
            [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,' + alpha + ')',
            [AppConstants.Break_Category_Id]: 'rgba(118, 162,39,' + alpha + ')',
            [AppConstants.Leave_Category_Id]: 'rgba(218,31,108,' + alpha + ')',
            [AppConstants.Duty_On_Call_Period_Category_Id]: 'rgba(80,83,90,' + alpha + ')',
            [AppConstants.Academic_Category_Id]: 'rgba(0,0,0,' + alpha + ')',
        };

        subCategories.forEach((element: any, index: any) => {
            if (element.categoryId != categoryId) {
                element.color = mapSubCategory[element.categoryId]
            } else {
                element.color = getSubCategoryOriginalColor(element.id)
            }
        });

        const clickedDataItem = series.data.find((item: any) => item.name === category);
        if (clickedDataItem) {
            // Set the clicked segment's data
            setClickedSegment({
                name: clickedDataItem.name,
                totalHours: clickedDataItem.totalHours,
                totalMinutes: clickedDataItem.totalMinutes,
                id: clickedDataItem.id,
            });
        }
        setCategories(categories);
        setSubCategories(subCategories);
    }

    const getSubCategoryOriginalColor = (subCategoryId: any) => {
        let ele = subCategoriesCopy.filter((x: { id: any; }) => x.id == subCategoryId)[0];
        return ele.color;
    }

    //To reset the chart on click of legends
    const reset = () => {
        setCategories(JSON.parse(JSON.stringify(categoriesCopy)));
        setSubCategories(JSON.parse(JSON.stringify(subCategoriesCopy)));
        setClickedSegment({});
    }

    //To render tooltip to onclick and onhover
    const renderTooltip = (context: any) => {
        const { category, series } = context.point || context; // Extract category and series information
        const dataItem = series.data.find((item: any) => item.name === category);
        return (
            <div>
                <p className="mb-1"> {category}</p>
                <p className="mb-1">{dataItem.totalSessions?.toFixed(2)} sessions</p>
                <p className="mb-1"> {dataItem.totalHours?.toFixed(0)}h {dataItem.totalMinutes?.toFixed(0)}m</p>
                <p className="mb-1"> {dataItem.percentage?.toFixed(1)}%</p>
            </div>
        )
    };

    //Avoid lightening on hover 
    const handleOnHoverState = (e: any) => {
        e.point.options.highlight.visible = false
    }

    //Activities with duty oncall category

    let subCategoriesToSetForWithDutyDay: any = [];
    const getColorForCategoryWithDutyDay = (category: any, subCategoryList: any) => {
        let subcategories = subCategoryList.filter((x: { categoryId: any; }) => x.categoryId == category.id);
        let total = 10 / subcategories.length;
        subcategories.forEach((element: any, index: any) => {
            let opacity = (total * (subcategories.length - index)) / 10;
            element.color = getColorForSubCategoryWithDutyDay(element, opacity);
            subCategoriesToSetForWithDutyDay.push(element);
        });
        let map: any = {
            [AppConstants.DCC_Category_Id]: '#0967B1',
            [AppConstants.ICC_Category_Id]: '#DA1F6C',
            [AppConstants.Non_Clinical_Work_Category_Id]: '#008E82',
            [AppConstants.Training_And_Supervision_Category_Id]: '#6F4F9B',
            [AppConstants.CPD_Category_Id]: '#EA580D',
            [AppConstants.Academic_Category_Id]: '#000000',
        };

        if (category.isUserDefined) {
            return '#76A227';
        } else {
            return map[category.id];
        }
    }

    //To get color for subcategory
    const getColorForSubCategoryWithDutyDay = (element: any, opacity: any) => {
        let alpha = opacity - 0.1;
        let map: any = {
            [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,' + alpha + ')',
            [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,' + alpha + ')',
            [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,' + alpha + ')',
            [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,' + alpha + ')',
            [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,' + alpha + ')',
            [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,' + alpha + ')',
        };

        if (element.isUserDefined) {
            return 'rgba(118, 162, 39,' + alpha + ')';
        } else {
            return map[element.categoryId];
        }
    }

    //Donut chart OnClick state
    const onSeriesClickForWithDutyDay = (event: any) => {
        if (event.dataItem.totalHours > 0 || event.dataItem.totalMinutes > 0) {
            const { category, series } = event.point;
            let categoryId = event.series.name == "categoriesForWithDutyDay" ? event.dataItem.id : event.dataItem.categoryId;
            let map: any = {
                [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,0.2)',
                [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,0.2)',
                [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,0.2)',
                [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,0.2)',
                [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,0.2)',
                [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,0.2)',
            };
            let mapO: any = {
                [AppConstants.DCC_Category_Id]: '#0967B1',
                [AppConstants.ICC_Category_Id]: '#DA1F6C',
                [AppConstants.Non_Clinical_Work_Category_Id]: '#008E82',
                [AppConstants.Training_And_Supervision_Category_Id]: '#6F4F9B',
                [AppConstants.CPD_Category_Id]: '#EA580D',
                [AppConstants.Academic_Category_Id]: '#000000',
            };
            categoriesForWithDutyDay.forEach((element: any) => {
                if (element.id != categoryId) {
                    element.color = element.isUserDefined ? 'rgba(118, 162, 39, 0.2)' : map[element.id];
                } else {
                    element.color = element.isUserDefined ? '#76A227' : mapO[element.id];
                }
            });

            let alpha = 0.2;
            let mapSubCategory: any = {
                [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,' + alpha + ')',
                [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,' + alpha + ')',
                [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,' + alpha + ')',
                [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,' + alpha + ')',
                [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,' + alpha + ')',
                [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,' + alpha + ')',
            };

            subCategoriesForWithDutyDay.forEach((element: any, index: any) => {
                if (element.categoryId != categoryId) {
                    element.color = element.isUserDefined ? 'rgba(118, 162, 39,' + alpha + ')' : mapSubCategory[element.categoryId]
                } else {
                    element.color = getSubCategoryOriginalColorWithDutyday(element.id)
                }
            });

            const clickedDataItem = series.data.find((item: any) => item.name === category);
            if (clickedDataItem) {
                // Set the clicked segment's data
                setClickedSegmentForWithDutyDay({
                    name: clickedDataItem.name,
                    totalHours: clickedDataItem.totalHours,
                    totalMinutes: clickedDataItem.totalMinutes,
                    id: clickedDataItem.id,
                });
            }
            setCategoriesForWithDutyDay(categoriesForWithDutyDay);
            setSubCategoriesForWithDutyDay(subCategoriesForWithDutyDay);
        }
    }

    const getSubCategoryOriginalColorWithDutyday = (subCategoryId: any) => {
        let ele = subCategoriesForWithDutyDayCopy.filter((x: { id: any; }) => x.id == subCategoryId)[0];
        return ele.color;
    }

    //To reset the chart on click of legends
    const resetForWithDutyDay = () => {
        if (totalSessionWithDutyDay > 0) {
            setCategoriesForWithDutyDay(JSON.parse(JSON.stringify(categoriesForWithDutyDayCopy)));
            setSubCategoriesForWithDutyDay(JSON.parse(JSON.stringify(subCategoriesForWithDutyDayCopy)));
            setClickedSegmentForWithDutyDay({});
        }
    }

    //To show the center of donut chart
    let centerWithDutyDay: any;
    let radiusWithDutyDay: any;

    //To create visuals for donut chart center
    const visualHandlerWithDutyDay = (e: SeriesVisualArgs) => {
        // Obtain parameters for the segments
        centerWithDutyDay = e.center;
        radiusWithDutyDay = e.innerRadius;

        // Create default visual
        return e.createVisual();
    };

    //To render the donut chart center
    const onRenderWithDutyDay = (e: RenderEvent) => {
        // The center and radius are populated by now.
        // We can ask a circle geometry to calculate the bounding rectangle for us.
        if (centerWithDutyDay) {
            const circleGeometry = new CircleGeometry([centerWithDutyDay.x, centerWithDutyDay.y], radiusWithDutyDay);
            const bbox = circleGeometry.bbox();

            // Render the text
            const heading = new Text(clickedSegmentForWithDutyDay.name ? Math.floor(clickedSegmentForWithDutyDay.totalHours) + 'h ' + clickedSegmentForWithDutyDay.totalMinutes.toFixed(1) + 'm' : Math.floor(averageHoursWithDutyDay) + 'h ' + averageMinutesWithDutyDay.toFixed(1) + 'm', [0, 0], {
                font: "bold 20px Helvetica Now,Helvetica,Arial,'sans- serif'",
            });

            const line1 = new Text(clickedSegmentForWithDutyDay.name ? clickedSegmentForWithDutyDay.name : '', [0, 0], {
                font: "bold 20px Helvetica Now,Helvetica,Arial,'sans- serif'",
            })

            // Reflow the text in the bounding box
            const layout = new Layout(bbox, {
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                spacing: 5,
                orientation: 'vertical'
            });

            layout.append(heading, line1);
            layout.reflow();

            // Draw it on the Chart drawing surface
            if (e.target.surface) {
                e.target.surface.draw(layout);
            }
        }
    };

    const onActionWithDutyDay = useCallback(
        (id: any) => {
            setExpandedForWithDutyDay({ ...expandedForWithDutyDay, [id]: !expandedForWithDutyDay[id] });
        },
        [expandedForWithDutyDay]
    );

    //To render tooltip to onclick and onhover
    const renderTooltipWithDutyDay = (context: any) => {
        if (totalSessionWithDutyDay > 0) {
            const { category, series } = context.point || context; // Extract category and series information
            const dataItem = series.data.find((item: any) => item.name === category);
            return (
                <div>
                    <p className="mb-1"> {category}</p>
                    <p className="mb-1">{dataItem.totalSessions?.toFixed(2)} sessions</p>
                    <p className="mb-1"> {dataItem.totalHours?.toFixed(0)}h {dataItem.totalMinutes?.toFixed(1)}m</p>
                    <p className="mb-1"> {dataItem.percentage?.toFixed(1)}%</p>
                </div>
            )
        }
    };

    //Activities with out duty oncall category
    let subCategoriesToSetForWithOutDutyDay: any = [];
    const getColorForCategoryWithOutDutyDay = (category: any, subCategoryList: any) => {
        let subcategories = subCategoryList.filter((x: { categoryId: any; }) => x.categoryId == category.id);
        let total = 10 / subcategories.length;
        subcategories.forEach((element: any, index: any) => {
            let opacity = (total * (subcategories.length - index)) / 10;
            element.color = getColorForSubCategoryWithOutDutyDay(element, opacity);
            subCategoriesToSetForWithOutDutyDay.push(element);
        });
        let map: any = {
            [AppConstants.DCC_Category_Id]: '#0967B1',
            [AppConstants.ICC_Category_Id]: '#DA1F6C',
            [AppConstants.Non_Clinical_Work_Category_Id]: '#008E82',
            [AppConstants.Training_And_Supervision_Category_Id]: '#6F4F9B',
            [AppConstants.CPD_Category_Id]: '#EA580D',
            [AppConstants.Academic_Category_Id]: '#000000',
        };

        if (category.isUserDefined) {
            return '#76A227';
        } else {
            return map[category.id];
        }
    }

    //To get color for subcategory
    const getColorForSubCategoryWithOutDutyDay = (element: any, opacity: any) => {
        let alpha = opacity - 0.1;
        let map: any = {
            [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,' + alpha + ')',
            [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,' + alpha + ')',
            [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,' + alpha + ')',
            [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,' + alpha + ')',
            [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,' + alpha + ')',
            [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,' + alpha + ')',
        };

        if (element.isUserDefined) {
            return 'rgba(118, 162, 39,' + alpha + ')';
        } else {
            return map[element.categoryId];
        }
    }

    //Donut chart OnClick state
    const onSeriesClickForWithOutDutyDay = (event: any) => {
        if (event.dataItem.totalHours > 0 || event.dataItem.totalMinutes > 0) {
            const { category, series } = event.point;
            let categoryId = event.series.name == "categoriesForWithoutDutyDay" ? event.dataItem.id : event.dataItem.categoryId;
            let map: any = {
                [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,0.2)',
                [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,0.2)',
                [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,0.2)',
                [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,0.2)',
                [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,0.2)',
                [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,0.2)',
            };
            let mapO: any = {
                [AppConstants.DCC_Category_Id]: '#0967B1',
                [AppConstants.ICC_Category_Id]: '#DA1F6C',
                [AppConstants.Non_Clinical_Work_Category_Id]: '#008E82',
                [AppConstants.Training_And_Supervision_Category_Id]: '#6F4F9B',
                [AppConstants.CPD_Category_Id]: '#EA580D',
                [AppConstants.Academic_Category_Id]: '#000000',
            };
            categoriesForWithoutDutyDay.forEach((element: any) => {
                if (element.id != categoryId) {
                    element.color = element.isUserDefined ? 'rgba(118, 162, 39, 0.2)' : map[element.id];
                } else {
                    element.color = element.isUserDefined ? '#76A227' : mapO[element.id];
                }
            });

            let alpha = 0.2;
            let mapSubCategory: any = {
                [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,' + alpha + ')',
                [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,' + alpha + ')',
                [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,' + alpha + ')',
                [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,' + alpha + ')',
                [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,' + alpha + ')',
                [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,' + alpha + ')',
            };

            subCategoriesForWithoutDutyDay.forEach((element: any, index: any) => {
                if (element.categoryId != categoryId) {
                    element.color = element.isUserDefined ? 'rgba(118, 162, 39,' + alpha + ')' : mapSubCategory[element.categoryId]
                } else {
                    element.color = getSubCategoryOriginalColorForWithOutDutyDay(element.id)
                }
            });

            const clickedDataItem = series.data.find((item: any) => item.name === category);
            if (clickedDataItem) {
                // Set the clicked segment's data
                setClickedSegmentForWithOutDutyDay({
                    name: clickedDataItem.name,
                    totalHours: clickedDataItem.totalHours,
                    totalMinutes: clickedDataItem.totalMinutes,
                    id: clickedDataItem.id,
                });
            }
            setCategoriesForWithoutDutyDay(categoriesForWithoutDutyDay);
            setSubCategoriesForWithoutDutyDay(subCategoriesForWithoutDutyDay);
        }
    }

    const getSubCategoryOriginalColorForWithOutDutyDay = (subCategoryId: any) => {
        let ele = subCategoriesForWithoutDutyDayCopy.filter((x: { id: any; }) => x.id == subCategoryId)[0];
        return ele.color;
    }

    //To reset the chart on click of legends
    const resetForWithOutDutyDay = () => {
        if (totalSessionWithOutDutyDay > 0) {
            setCategoriesForWithoutDutyDay(JSON.parse(JSON.stringify(categoriesForWithoutDutyDayCopy)));
            setSubCategoriesForWithoutDutyDay(JSON.parse(JSON.stringify(subCategoriesForWithoutDutyDayCopy)));
            setClickedSegmentForWithOutDutyDay({});
        }
    }

    let centerWithOutDutyDay: any;
    let radiusWithOutDutyDay: any;

    //To create visuals for donut chart center
    const visualHandlerWithOutDutyDay = (e: SeriesVisualArgs) => {
        // Obtain parameters for the segments
        centerWithOutDutyDay = e.center;
        radiusWithOutDutyDay = e.innerRadius;

        // Create default visual
        return e.createVisual();
    };

    //To render the donut chart center
    const onRenderWithOutDutyDay = (e: RenderEvent) => {
        // The center and radius are populated by now.
        // We can ask a circle geometry to calculate the bounding rectangle for us.
        if (centerWithOutDutyDay) {
            const circleGeometry = new CircleGeometry([centerWithOutDutyDay.x, centerWithOutDutyDay.y], radiusWithOutDutyDay);
            const bbox = circleGeometry.bbox();

            // Render the text
            const heading = new Text(clickedSegmentForWithOutDutyDay.name ? Math.floor(clickedSegmentForWithOutDutyDay.totalHours) + 'h ' + clickedSegmentForWithOutDutyDay.totalMinutes.toFixed(1) + 'm' : Math.floor(averageHoursWithOutDutyDay) + 'h ' + averageMinutesWithOutDutyDay.toFixed(1) + 'm', [0, 0], {
                font: "bold 20px Helvetica Now,Helvetica,Arial,'sans- serif'",
            });

            const line1 = new Text(clickedSegmentForWithOutDutyDay.name ? clickedSegmentForWithOutDutyDay.name : '', [0, 0], {
                font: "bold 20px Helvetica Now,Helvetica,Arial,'sans- serif'",
            })

            // Reflow the text in the bounding box
            const layout = new Layout(bbox, {
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                spacing: 5,
                orientation: 'vertical'
            });

            layout.append(heading, line1);
            layout.reflow();

            // Draw it on the Chart drawing surface
            if (e.target.surface) {
                e.target.surface.draw(layout);
            }
        }
    };

    const onActionFOrWithOutDutyDay = useCallback(
        (id: any) => {
            setExpandedForWithOutDutyDay({ ...expandedForWithOutDutyDay, [id]: !expandedForWithOutDutyDay[id] });
        },
        [expandedForWithOutDutyDay]
    );

    //To render tooltip to onclick and onhover
    const renderTooltipForWithOutDutyDay = (context: any) => {
        if (totalSessionWithOutDutyDay > 0) {
            const { category, series } = context.point || context; // Extract category and series information
            const dataItem = series.data.find((item: any) => item.name === category);
            return (
                <div>
                    <p className="mb-1"> {category}</p>
                    <p className="mb-1">{dataItem.totalSessions?.toFixed(2)} sessions</p>
                    <p className="mb-1"> {dataItem.totalHours?.toFixed(0)}h {dataItem.totalMinutes?.toFixed(1)}m</p>
                    <p className="mb-1"> {dataItem.percentage?.toFixed(1)}%</p>
                </div>
            )
        }
    };

    return (
        <>
            {props.dutyOnCallCategoryExist &&
                <div>
                    <p className="mb-3">Total number of duty/on-call periods</p>
                    <p className="text-secondary">Number of weeks in reporting period: {totalWeeks}. Number of duty/on-call periods: {totalDutyOnCallPeriod}.</p>
                </div>
            }
            {props.isOnDutyCategoryExist &&
                <div>
                    <p className="mb-3">DCC/ICC carried out as part of duty/on-call</p>
                    <p className="text-secondary">The activities directly related to duty/on-call work would have been checked as 'work carried out while on duty/on-call' when you added them to your diary.</p>
                    <div className="Container-fluid">
                        <div className="row">
                            <div className="col-lg-6" onClick={reset}>
                                <Chart transitions={false} onRender={onRender} onSeriesClick={onSeriesClick} onSeriesHover={handleOnHoverState}>
                                    <ChartTooltip render={renderTooltip} background="#fff" />
                                    <ChartLegend visible={false} />
                                    <ChartArea background="none" />
                                    <ChartSeries>
                                        <ChartSeriesItem visual={visualHandler}
                                            name="subCategories"
                                            data={subCategories}
                                            width={500}
                                            type="donut"
                                            startAngle={0}
                                            field="totalSessions"
                                            categoryField="name"
                                            colorField="color"
                                            size={40}
                                            holeSize={50}
                                            margin={3}
                                        >
                                        </ChartSeriesItem>
                                        <ChartSeriesItem visual={visualHandler}
                                            name="categories"
                                            data={categories}
                                            width={500}
                                            type="donut"
                                            startAngle={0}
                                            field="totalSessions"
                                            categoryField="name"
                                            colorField="color"
                                            size={60}
                                            holeSize={50}
                                            margin={3}
                                        >
                                        </ChartSeriesItem>
                                    </ChartSeries>
                                </Chart>
                            </div>
                            <div className="col-lg-2" onClick={reset}></div>
                            <div className="col-lg-4 mt-5">
                                {categories.map((item: any, index: any) => (
                                    <Fragment key={index}>
                                        <ExpansionPanel
                                            expandIcon="k-icon k-i-arrow-60-right"
                                            collapseIcon="k-icon k-i-arrow-60-down"
                                            style={{ border: 'none', borderBottom: "2px solid lightgrey" }}
                                            expanded={expanded[item.id]}
                                            tabIndex={0}
                                            key={item.id}
                                            onAction={onAction.bind(undefined, item.id)}
                                            title={
                                                <div className="row mt-2">
                                                    <span className="mr-2">
                                                        <svg width="50" height="50">
                                                            <circle cx="25" cy="25" r="25" fill={item.color} fillOpacity="0.3" />
                                                            <circle cx="25" cy="25" r="15" fill={item.color} fillOpacity="0.7" />
                                                            <circle cx="25" cy="25" r="5" fill={item.color} fillOpacity="1" />
                                                        </svg>
                                                        <label className="text-dark ps-2">{item.name} - {item.totalHours}h {item.totalMinutes}m ({item?.percentage > 0 ? item?.percentage?.toFixed(1) : 0}%)</label>
                                                    </span>
                                                </div>
                                            }
                                        />
                                        {subCategories.filter((x: any) => x.categoryId == item.id).map((sub: any, index: any) => (
                                            <Fragment key={index}>
                                                {expanded[item.id] && (
                                                    <div className="container-fluid">
                                                        <ExpansionPanelContent>
                                                            <div className="row mt-2">
                                                                <span className="col-1 ps-4 ms-1">
                                                                    <svg width="20" height="20">
                                                                        <circle cx="10" cy="10" r="10" fill={sub.color} />
                                                                    </svg>
                                                                </span>
                                                                <label className="col-5 ps-4 ms-1 pe-0 text-break">{sub.name}</label>
                                                                <label className="col-5 ps-1 pe-0 text-break">{sub.totalHours}h {sub.totalMinutes}m ({sub?.percentage > 0 ? sub?.percentage?.toFixed(1) : 0}%)</label>
                                                            </div>
                                                        </ExpansionPanelContent>
                                                    </div>
                                                )}
                                            </Fragment>
                                        ))}
                                    </Fragment>
                                ))}
                            </div>
                        </div>
                    </div><br />
                </div>
            }
            {props.dutyOnCallCategoryExist &&
                <div>
                    <p className="mb-3">Average work on duty/on-call, each week</p>
                    {categoriesWithDutyDayExist ?
                        (<div>
                            <p className="text-secondary">These are all the activities you carry out on a duty day but may not be directly related to duty/on-call work.</p>
                        </div>)
                        : (
                            <div>
                                <p className="text-secondary">You do not have any activities in your diary that occur during duty/on-call periods. Enter duty/on-call periods in your diary to see this report. Duty/on-call periods can occur at the same time as other work activities.</p>
                            </div>
                        )
                    }
                    <div className="Container-fluid">
                        <div className="row">
                            <div className="col-lg-6" onClick={resetForWithDutyDay}>
                                <Chart transitions={false} onRender={onRenderWithDutyDay} onSeriesClick={onSeriesClickForWithDutyDay} onSeriesHover={handleOnHoverState}>
                                    <ChartTooltip render={renderTooltipWithDutyDay} background="#fff" />
                                    <ChartLegend visible={false} />
                                    <ChartArea background="none" />
                                    <ChartSeries>
                                        <ChartSeriesItem visual={visualHandlerWithDutyDay}
                                            name="subCategoriesForWithDutyDay"
                                            data={subCategoriesForWithDutyDay}
                                            width={500}
                                            type="donut"
                                            startAngle={0}
                                            field="totalSessions"
                                            categoryField="name"
                                            colorField="color"
                                            size={40}
                                            holeSize={50}
                                            margin={3}
                                        >
                                        </ChartSeriesItem>
                                        <ChartSeriesItem visual={visualHandlerWithDutyDay}
                                            name="categoriesForWithDutyDay"
                                            data={categoriesForWithDutyDay}
                                            width={500}
                                            type="donut"
                                            startAngle={0}
                                            field="totalSessions"
                                            categoryField="name"
                                            colorField="color"
                                            size={60}
                                            holeSize={50}
                                            margin={3}
                                        >
                                        </ChartSeriesItem>
                                    </ChartSeries>
                                </Chart>
                            </div>
                            <div className="col-lg-2" onClick={resetForWithDutyDay}></div>
                            <div className="col-lg-4 mt-5">
                                {categoriesForWithDutyDay.map((item: any, index: any) => (
                                    <Fragment key={index}>
                                        <ExpansionPanel
                                            expandIcon="k-icon k-i-arrow-60-right"
                                            collapseIcon="k-icon k-i-arrow-60-down"
                                            style={{ border: 'none', borderBottom: "2px solid lightgrey" }}
                                            expanded={expandedForWithDutyDay[item.id]}
                                            tabIndex={0}
                                            key={item.id}
                                            onAction={onActionWithDutyDay.bind(undefined, item.id)}
                                            title={
                                                <div className="row mt-2">
                                                    <span className="mr-2">
                                                        <svg width="50" height="50">
                                                            <circle cx="25" cy="25" r="25" fill={item.color} fillOpacity="0.3" />
                                                            <circle cx="25" cy="25" r="15" fill={item.color} fillOpacity="0.7" />
                                                            <circle cx="25" cy="25" r="5" fill={item.color} fillOpacity="1" />
                                                        </svg>
                                                        <label className="text-dark ps-2">{item.name} - {item.totalHours.toFixed(0)}h {item.totalMinutes.toFixed(1)}m ({item?.percentage > 0 ? item?.percentage?.toFixed(1) : 0}%)</label>
                                                    </span>
                                                </div>
                                            }
                                        />
                                        {subCategoriesForWithDutyDay.filter((x: any) => x.categoryId == item.id).map((sub: any, index: any) => (
                                            <Fragment key={index}>
                                                {expandedForWithDutyDay[item.id] && (
                                                    <div className="container-fluid">
                                                        <ExpansionPanelContent>
                                                            <div className="row mt-2">
                                                                <span className="col-1 ps-4 ms-1">
                                                                    <svg width="20" height="20">
                                                                        <circle cx="10" cy="10" r="10" fill={sub.color} />
                                                                    </svg>
                                                                </span>
                                                                <label className="col-5 ps-4 ms-1 pe-0 text-break">{sub.name}</label>
                                                                <label className="col-5 ps-1 pe-0 text-break">{sub.totalHours.toFixed(0)}h {sub.totalMinutes.toFixed(1)}m ({sub?.percentage > 0 ? sub?.percentage?.toFixed(1) : 0}%)</label>
                                                            </div>
                                                        </ExpansionPanelContent>
                                                    </div>
                                                )}
                                            </Fragment>
                                        ))}
                                    </Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                    <br />
                    <p className="mb-3">Average work not on duty/on-call, each week</p>
                    <p className="text-muted">This excludes work done on leave, public holidays and weekends.</p>
                    {!categoriesWithOutDutyDayExist &&
                        (
                            <div>
                                <p className="text-secondary">You do not have any activities in your diary that occur outside of duty/on-call periods, over the reporting period.</p>
                            </div>)
                    }
                    <div className="Container-fluid">
                        <div className="row">
                            <div className="col-lg-6" onClick={resetForWithOutDutyDay}>
                                <Chart transitions={false} onRender={onRenderWithOutDutyDay} onSeriesClick={onSeriesClickForWithOutDutyDay} onSeriesHover={handleOnHoverState}>
                                    <ChartTooltip render={renderTooltipForWithOutDutyDay} background="#fff" />
                                    <ChartLegend visible={false} />
                                    <ChartArea background="none" />
                                    <ChartSeries>
                                        <ChartSeriesItem visual={visualHandlerWithOutDutyDay}
                                            name="subCategoriesForWithoutDutyDay"
                                            data={subCategoriesForWithoutDutyDay}
                                            width={500}
                                            type="donut"
                                            startAngle={0}
                                            field="totalSessions"
                                            categoryField="name"
                                            colorField="color"
                                            size={40}
                                            holeSize={50}
                                            margin={3}
                                        >
                                        </ChartSeriesItem>
                                        <ChartSeriesItem visual={visualHandlerWithOutDutyDay}
                                            name="categoriesForWithoutDutyDay"
                                            data={categoriesForWithoutDutyDay}
                                            width={500}
                                            type="donut"
                                            startAngle={0}
                                            field="totalSessions"
                                            categoryField="name"
                                            colorField="color"
                                            size={60}
                                            holeSize={50}
                                            margin={3}
                                        >
                                        </ChartSeriesItem>
                                    </ChartSeries>
                                </Chart>
                            </div>
                            <div className="col-lg-2" onClick={resetForWithOutDutyDay}></div>
                            <div className="col-lg-4 mt-5">
                                {categoriesForWithoutDutyDay.map((item: any, index: any) => (
                                    <Fragment key={index}>
                                        <ExpansionPanel
                                            expandIcon="k-icon k-i-arrow-60-right"
                                            collapseIcon="k-icon k-i-arrow-60-down"
                                            style={{ border: 'none', borderBottom: "2px solid lightgrey" }}
                                            expanded={expandedForWithOutDutyDay[item.id]}
                                            tabIndex={0}
                                            key={item.id}
                                            onAction={onActionFOrWithOutDutyDay.bind(undefined, item.id)}
                                            title={
                                                <div className="row mt-2">
                                                    <span className="mr-2">
                                                        <svg width="50" height="50">
                                                            <circle cx="25" cy="25" r="25" fill={item.color} fillOpacity="0.3" />
                                                            <circle cx="25" cy="25" r="15" fill={item.color} fillOpacity="0.7" />
                                                            <circle cx="25" cy="25" r="5" fill={item.color} fillOpacity="1" />
                                                        </svg>
                                                        <label className="text-dark ps-2">{item.name} - {item.totalHours.toFixed(0)}h {item.totalMinutes.toFixed(1)}m ({item?.percentage > 0 ? item?.percentage?.toFixed(1) : 0}%)</label>
                                                    </span>
                                                </div>
                                            }
                                        />
                                        {subCategoriesForWithoutDutyDay.filter((x: any) => x.categoryId == item.id).map((sub: any, index: any) => (
                                            <Fragment key={index}>
                                                {expandedForWithOutDutyDay[item.id] && (
                                                    <div className="container-fluid">
                                                        <ExpansionPanelContent>
                                                            <div className="row mt-2">
                                                                <span className="col-1 ps-4 ms-1">
                                                                    <svg width="20" height="20">
                                                                        <circle cx="10" cy="10" r="10" fill={sub.color} />
                                                                    </svg>
                                                                </span>
                                                                <label className="col-5 ps-4 ms-1 pe-0 text-break">{sub.name}</label>
                                                                <label className="col-5 ps-1 pe-0 text-break">{sub.totalHours.toFixed(0)}h {sub.totalMinutes.toFixed(1)}m ({sub?.percentage > 0 ? sub?.percentage?.toFixed(1) : 0}%)</label>
                                                            </div>
                                                        </ExpansionPanelContent>
                                                    </div>
                                                )}
                                            </Fragment>
                                        ))}
                                    </Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}